// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2ISny","empty":"ModalGraph_empty__r3WBS"};